import { observer } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';

import { Align } from './TextSettingsUI';

type Props = {
  alignType: Align;
  toggleAlign: (align: Align) => void;
};

const AlignFormatting: React.FC<Props> = observer(props => {
  const { alignType, toggleAlign } = props;
  return (
    <>
      {(Object.keys(Align) as Array<keyof typeof Align>).map(alignKey => (
        <ActionButton
          key={alignKey}
          isSelected={alignType === Align[alignKey]}
          onClick={() => {
            toggleAlign(Align[alignKey]);
          }}
        >
          {
            {
              [Align.leftAlign]: 'Left',
              [Align.midAlign]: 'Center',
              [Align.rightAlign]: 'Right',
            }[Align[alignKey]]
          }
        </ActionButton>
      ))}
    </>
  );
});

export default AlignFormatting;

const ActionButton = styled.button<{ isSelected: boolean }>`
  outline: 0;
  border: 1px solid
    ${props => (props.isSelected ? 'var(--accent)' : 'var(--border)')};
  width: 100%;
  height: 42px;
  background-color: ${props =>
    props.isSelected ? 'var(--accent)' : 'var(--background)'};
  border-radius: var(--radius);
  color: ${props =>
    props.isSelected ? 'var(--background)' : 'var(--text-secondary)'};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  span.filler {
    font-weight: var(--font-weight-normal);
    font-size: 11px;
    line-height: 9.68px;
    color: ${props =>
      props.isSelected ? 'var(--background)' : 'var(--foreground)'};
  }
`;
